export default function() {

  var selectedYear=null;
  var selectedCategory=null;
  var containers=$(".news-list.not-slider");
  var items=$(".news-list.not-slider>li");

  var doNewsFilter=function() {
    var current=0;
    for(var i=0;i<items.length;i++) {
      var foundYear=!selectedYear || items.eq(i).attr("data-year")==selectedYear;
      var foundCategory=!selectedCategory || items.eq(i).attr("data-category")==selectedCategory;
      if (foundYear && foundCategory) {
        containers.eq(Math.floor(current/3)).append(items.eq(i).show());
        items.eq(i).find(".to-anim").addClass('end-anim');
        current++;
      } else {
        items.eq(i).hide();
      }
    }
  }
  $(".news-list-head .select:eq(0) li").click(function() {
    selectedYear=$(this).attr("data-value") || null;
    $(".news-list-head .select:eq(0) .current").html("Year: "+$(this).find("em").html());
    doNewsFilter();
  });
  $(".news-list-head .select:eq(1) li").click(function() {
    console.log(selectedCategory);
    selectedCategory=$(this).attr("data-value") || null;
    $(".news-list-head .select:eq(1) .current").html("Category: "+$(this).find("em").html());
    doNewsFilter();
  });
}
